export default __webpack_public_path__ + "static/media/PlocastaKomoraGrejac.4f2c2a19.png";